import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CodaltComponent } from 'src/app/codalt.component';
import { AuthService } from 'src/app/services/auth/auth.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-login-as-dirk-user',
    templateUrl: './login-as-dirk-user.component.html',
    standalone: false,
})
export class LoginAsDirkUserComponent extends CodaltComponent implements OnInit {
    constructor(
        private authService: AuthService,
        private route: ActivatedRoute,
        private router: Router
    ) {
        super();
    }

    ngOnInit() {
        const userId = +(this.route.snapshot.paramMap.get('userId') ?? 0);

        if (!userId || !environment.dirkAppUrl) {
            this.router.navigate(['/gebruikers'], { replaceUrl: true });
            return;
        }

        this.subscriptions.add(
            this.authService.loginAsDirkUser(userId).subscribe({
                next: response => {
                    const params = new URLSearchParams({
                        token: response.data.access_token,
                        parentToken: response.data.parent_access_token,
                        parentUserId: String(response.data.parent_user.id),
                        parentUserName: response.data.parent_user.name,
                    });
                    window.location.href = `${environment.dirkAppUrl}take-over?${params.toString()}`;
                },
                error: () => this.router.navigate(['/gebruikers', userId], { replaceUrl: true }),
            })
        );
    }
}
